/**
 * @generated SignedSource<<828f317557ded06f646c4e94e2cdec2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAddItemToCart_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useAddItemToCart_user";
};
export type useAddItemToCart_user$key = {
  readonly " $data"?: useAddItemToCart_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAddItemToCart_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "35ce19d57857d486c6874c4b53e64bf1";

export default node;
